const Stackoverflow = () => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="social-icon hoverable"
      aria-label="Shakeel Haider's Stack Overflow Profile"
    >
      <g clipPath="url(#clip0_141_178)">
        <path
          d="M170 0H30C13.4315 0 0 13.4315 0 30V170C0 186.569 13.4315 200 30 200H170C186.569 200 200 186.569 200 170V30C200 13.4315 186.569 0 170 0Z"
          fill="#F58025"
        />
        <path
          d="M114.453 34.7656L149.609 81.6406M93.75 54.2969L138.672 92.1875M77.7344 79.6875L130.859 104.688M68.75 106.641L126.562 118.75M66.4062 133.203H125M48.8281 116.016V157.031H142.969V116.016"
          stroke="white"
          strokeWidth="12"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_178">
          <rect width="200" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Stackoverflow;
